var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAfterSuccessBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 500,
    viewBox: "0 0 1440 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M702.818 91.7997L422.474 374.31C398.75 398.218 370.213 416.808 338.757 428.847L168.149 494.145L1303.23 522L735.15 89.5556C725.336 82.0848 711.505 83.0448 702.818 91.7997Z",
    fill: "url(#paint0_linear_46_920)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 84,
    width: 787,
    height: 412
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.384 91.6636L399 397L332 495.374L1063.77 464.286C1117.52 462.002 1138.82 393.616 1095.87 361.21L735.592 89.3954C725.796 82.0041 712.048 82.9723 703.384 91.6636Z",
    fill: "url(#paint1_linear_46_920)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.33 195.84C641.063 220.418 608.484 195.84 601.248 185.599L715.124 66.8076L865.457 165.937C869.007 175.632 818.022 172.573 787.218 195.84C756.414 219.107 717.035 208.539 715.124 195.84C707.887 185.599 687.597 171.263 664.33 195.84Z",
    fill: "url(#paint2_linear_46_920)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721 0C722.657 0 724 1.2042 724 2.68966V88.3103C724 89.7958 722.657 91 721 91C719.343 91 718 89.7958 718 88.3103V2.68966C718 1.2042 719.343 0 721 0Z",
    fill: "url(#paint3_linear_46_920)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M763.445 19.6001L723.332 5.46932C722.682 5.24016 722 5.7228 722 6.41251V36.0416C722 36.744 722.705 37.2275 723.36 36.9744L763.474 21.4761C764.34 21.1413 764.322 19.9088 763.445 19.6001Z",
    fill: "#EA5505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.096 211.107L22.9828 458.711L-27 538.161L393.365 600.312C446.293 608.137 484.031 550.285 455.539 504.999L272.447 213.986C262.73 198.543 240.769 197.084 229.096 211.107Z",
    fill: "url(#paint4_linear_46_920)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_46_920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -27,
    y: 201,
    width: 493,
    height: 401
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M229.096 211.107L22.9828 458.711L-27 538.161L393.365 600.312C446.293 608.137 484.031 550.285 455.539 504.999L272.447 213.986C262.73 198.543 240.769 197.084 229.096 211.107Z",
    fill: "url(#paint5_linear_46_920)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_46_920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.026 292.723C180.839 315.104 162.363 302.049 155.773 292.723L248.278 175.227L313.927 247.963C317.16 256.791 341.977 271.537 313.927 292.723C285.877 313.91 250.019 304.287 248.278 292.723C241.689 283.398 223.212 270.343 202.026 292.723Z",
    fill: "url(#paint6_linear_46_920)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.75 235.085L1438.02 392.865L1488 442.257L1107.13 477.265C1048.58 482.646 1015.55 411.67 1057.38 370.342L1191.82 237.498C1201.26 228.166 1216.11 227.141 1226.75 235.085Z",
    fill: "url(#paint7_linear_46_920)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_46_920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1038,
    y: 229,
    width: 450,
    height: 249
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1226.75 235.085L1438.02 392.865L1488 442.257L1107.13 477.265C1048.58 482.646 1015.55 411.67 1057.38 370.342L1191.82 237.498C1201.26 228.166 1216.11 227.141 1226.75 235.085Z",
    fill: "url(#paint8_linear_46_920)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_46_920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1258.97 289.675C1280.16 303.588 1298.64 295.472 1305.23 289.675L1212.72 216.629L1147.07 261.848C1143.84 267.336 1119.02 276.503 1147.07 289.675C1175.12 302.846 1210.98 296.863 1212.72 289.675C1219.31 283.877 1237.79 275.761 1258.97 289.675Z",
    fill: "url(#paint9_linear_46_920)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.45 436.834C1369.14 322.97 1440.06 390.909 1617 445.943L1617 482H918C918 482 1024.53 474.651 1110.45 436.834Z",
    fill: "url(#paint10_linear_46_920)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 409.814C347.5 481.834 236.5 350.5 80.9999 330C46.9215 325.507 12.1397 329.885 -21 339.218L-6.50001 527H1520.77V397.894C1461.58 436.661 1378.08 447.383 1263 397.894C916.5 248.887 821.5 337.795 584.5 409.814Z",
    fill: "url(#paint11_diamond_46_920)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1342 370.606C1342 382.462 1332.39 392.074 1320.53 392.074C1308.68 392.074 1299.06 382.462 1299.06 370.606C1299.06 358.749 1308.68 338.133 1320.53 338.133C1332.39 338.133 1342 358.749 1342 370.606Z",
    fill: "url(#paint12_linear_46_920)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1321.08 432.355V354.928",
    stroke: "#7E7E7E",
    strokeWidth: 0.838607
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.78 362.436L1321.28 379.626L1328.59 368.956",
    stroke: "#7E7E7E",
    strokeWidth: 0.838607
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1181 330.722C1181 349.434 1165.55 364.604 1146.5 364.604C1127.45 364.604 1112 349.434 1112 330.722C1112 312.009 1127.45 279.472 1146.5 279.472C1165.55 279.472 1181 312.009 1181 330.722Z",
    fill: "url(#paint13_linear_46_920)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.11 409L1147.11 306.104",
    stroke: "#7E7E7E",
    strokeWidth: 0.605272
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.04 317.828L1147.7 344.958L1159.45 328.119",
    stroke: "#7E7E7E",
    strokeWidth: 0.605272
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.078 509.113C209.312 481.748 163.656 424.466 91.156 484.404C94.5974 466.338 92.3031 431.32 55.5945 435.784C24.1017 439.613 16.8126 459.751 17.0672 473.449C14.1699 454.369 2.62331 426.202 -26.9999 430.204V509.113H223.078Z",
    fill: "url(#paint14_linear_46_920)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.408,
    cy: 416.914,
    r: 34.2363,
    fill: "url(#paint15_linear_46_920)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.17,
    cy: 445.334,
    r: 18.451,
    fill: "url(#paint16_linear_46_920)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M320.395 464.314C320.395 471.022 314.957 476.459 308.25 476.459C301.542 476.459 296.105 471.022 296.105 464.314C296.105 457.607 301.542 452.169 308.25 452.169C314.957 452.169 320.395 457.607 320.395 464.314Z",
    fill: "url(#paint17_linear_46_920)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.648 408.282L292.648 552",
    stroke: "#B7B7B7",
    strokeWidth: 0.825964
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.363 445.03L292.836 467.391",
    stroke: "#B7B7B7",
    strokeWidth: 0.825964
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M306.353 413.597L292.404 431.426",
    stroke: "#B7B7B7",
    strokeWidth: 0.412982
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M284.208 411.845L292.413 419.735",
    stroke: "#B7B7B7",
    strokeWidth: 0.412982
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M309.182 463.785L292.788 478.906",
    stroke: "#B7B7B7",
    strokeWidth: 0.825964
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M804.986 507.31C807.643 495.972 805.019 483.5 797.818 474.361C791.119 465.859 780.375 460.326 769.597 461.162C758.819 461.998 748.591 469.835 746.118 480.384C741.277 458.716 732.517 437.086 716.22 422.044C699.924 407.002 674.867 400.063 654.885 409.648C642.672 415.509 633.652 426.708 627.82 438.958C621.988 451.207 619.008 464.606 616.071 477.852C613.129 470.956 607.658 462.71 600.438 464.606C595.852 465.807 593.332 470.78 592.218 475.378C591.105 479.975 590.731 484.996 587.988 488.881C588.083 484.473 586.865 479.857 583.767 476.727C580.668 473.597 575.472 472.385 571.71 474.67C565.049 478.707 566.793 489.56 561.288 495.093C559.08 489.323 555.285 483.143 549.184 482.303C543.702 481.548 538.496 485.708 536.198 490.752C533.901 495.796 533.83 501.543 533.83 507.086L804.986 507.31Z",
    fill: "url(#paint18_linear_46_920)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_920",
    x1: 936.903,
    y1: 93.3519,
    x2: 937.018,
    y2: 339.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_920",
    x1: 936.085,
    y1: 93.3519,
    x2: 936.2,
    y2: 339.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_46_920",
    x1: 787.134,
    y1: 63.1986,
    x2: 787.172,
    y2: 139.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_46_920",
    x1: 721,
    y1: 0,
    x2: 721,
    y2: 91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCCB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_46_920",
    x1: 523.079,
    y1: 172.08,
    x2: 450.501,
    y2: 547.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C2C6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_46_920",
    x1: 501.354,
    y1: 206.845,
    x2: 527.749,
    y2: 494.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BCB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_46_920",
    x1: 313.85,
    y1: 171.94,
    x2: 313.885,
    y2: 241.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_46_920",
    x1: 937.922,
    y1: 214.673,
    x2: 937.881,
    y2: 353.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3C0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EAF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_46_920",
    x1: 959.646,
    y1: 236.286,
    x2: 949.393,
    y2: 416.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBAEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_46_920",
    x1: 1147.15,
    y1: 214.586,
    x2: 1147.14,
    y2: 257.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_46_920",
    x1: 1267.45,
    y1: 362.531,
    x2: 1267,
    y2: 539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_diamond_46_920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(770 156.5) rotate(86.161) scale(306.187 3371.35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBEAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_46_920",
    x1: 1320.53,
    y1: 328.704,
    x2: 1320.54,
    y2: 377.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_46_920",
    x1: 1146.5,
    y1: 264.591,
    x2: 1146.51,
    y2: 341.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_46_920",
    x1: 98.0203,
    y1: 415.96,
    x2: 98.0202,
    y2: 487.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_46_920",
    x1: 292.413,
    y1: 370.709,
    x2: 292.413,
    y2: 432.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_46_920",
    x1: 269.172,
    y1: 420.433,
    x2: 269.173,
    y2: 453.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_46_920",
    x1: 308.252,
    y1: 447.924,
    x2: 308.252,
    y2: 469.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_46_920",
    x1: 669.935,
    y1: 387.405,
    x2: 669.935,
    y2: 479.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BECBA2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterSuccessBg);
export default __webpack_public_path__ + "static/media/afterSuccessBG.af557527698ecffe5a254ec904822070.svg";
export { ForwardRef as ReactComponent };